import React from 'react';
import image1 from '../../assets/cfye-images/image1.png';
import image2 from '../../assets/cfye-images/image2.png';
import image3 from '../../assets/cfye-images/image3.png';

export default function About() {
  const cards = [
    {
      image: image1,
      title:
        'Empowering women in business: CFYE, Shecluded collaborate to create jobs',
      link: 'https://businessday.ng/uncategorized/article/empowering-women-in-business-cfye-shecluded-collaborate-to-create-jobs/',
    },
    {
      image: image2,
      title:
        "Shecluded was selected as an Implementing Partner for CFYE's initiative to reduce youth unemployment",
      link: 'https://fundforyouthemployment.nl/nigeria-selection-shecluded/',
    },
    {
      image: image3,
      title:
        'In July 2023, Shecluded was selected as an Implementing Partner for the Challenge Fund for Youth Employment (CFYE)',
      link: 'https://blog.shecluded.com/empowering-women-entrepreneurs-finwomens-transformative-impact-in-year-1/',
    },
  ];

  return (
    <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Heading with left-leaning title and right rule */}
        <div className="flex items-center mb-8 sm:mb-12 w-full">
          {/* left short rule, responsive */}
          <div className="w-12 md:w-20 h-px bg-dark-grey-3 flex-none"></div>

          {/* heading */}
          <h2 className="px-3 md:px-4 text-xl sm:text-2xl md:text-3xl whitespace-nowrap ml-4">
            READ MORE ABOUT US
          </h2>

          {/* right flexible rule */}
          <div className="flex-1 h-px bg-dark-grey-3 ml-4"></div>
        </div>

        {/* Cards grid: 1 / 2 / 3 columns depending on screen */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {cards.map((card, index) => (
            <article
              key={index}
              className="flex flex-col h-full bg-white"
              aria-labelledby={`card-title-${index}`}
            >
              {/* Image: responsive fixed heights so cards align in a row */}
              <div className="mb-4 overflow-hidden rounded-lg w-full h-48 sm:h-56 md:h-64 lg:h-72">
                <img
                  src={card.image}
                  alt={card.title}
                  loading="lazy"
                  className="w-full h-full object-cover transform transition-transform duration-300 hover:scale-105"
                />
              </div>

              {/* Content */}
              <div className="flex flex-col flex-1">
                <h3
                  id={`card-title-${index}`}
                  className="text-base md:text-lg lg:text-xl font-semibold mb-3 leading-relaxed text-gray-900"
                >
                  {card.title}
                </h3>

                <div className="mt-auto">
                  <a
                    href={card.link}
                    className="text-primary font-semibold inline-flex items-center hover:text-pink-700 transition-colors"
                  >
                    Read More
                    <span className="ml-2" aria-hidden>
                      ›
                    </span>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
